import React from 'react';
import { useSelector } from 'react-redux';
import { Map } from 'mapbox-gl';

import { SettingsModal } from 'modules/settings';
import { CollapsibleContainer, Button, Badge } from 'modules/ui/components';
import { useModal } from 'modules/main';
import { isOnlineSelector, isUiVisibleSelector } from 'modules/metadata';
import { useDisplayCurrentLocation } from 'modules/location';
import { useGetUser, useGetUserPlanInfo } from 'modules/user';

import Header from './Header';
import { BoatSideMenuSection } from '../BoatSideMenuSection';
import { ConnectionSideMenuSection } from '../ConnectionSideMenuSection';
import { FleetSideMenuSection } from '../FleetSideMenuSection';
import { SubscriptionSideMenuSection } from '../SubscriptionSideMenuSection';

import {
  BadgeContainer,
  ButtonsContainer,
  OfflineText,
} from './styledComponents';
import { LocationHeader } from './LocationHeader';

type Props = {
  onModeChange: (value: boolean) => void;
  onVisibilityChange: (value: string | null) => void;
  id: string;
  isOpened: boolean;
  map: Map;
};

const HomeSideMenu: React.FC<Props> = ({
  // onModeChange,
  isOpened,
  onVisibilityChange,
  id,
  map,
}) => {
  const isOnline = useSelector(isOnlineSelector);
  const isUiVisible = useSelector(isUiVisibleSelector);
  const pricingEnabled = process.env.REACT_APP_STRIPE_ENABLED === 'true';
  useGetUser();
  useDisplayCurrentLocation(map);
  const { name: planName } = useGetUserPlanInfo();

  const showFleetData = false;

  const [isSettingsModalOpen, , openSettingsModal, closeSettingsModal] =
    useModal(false);

  return (
    <>
      {isSettingsModalOpen && (
        <SettingsModal
          isOpen={isSettingsModalOpen}
          closeModal={closeSettingsModal}
        />
      )}
      <CollapsibleContainer
        isVisible={isUiVisible}
        opacity={0.8}
        isOpened={isOpened}
        onVisibilityChange={onVisibilityChange}
        id={id}
        title="General"
        RightTitleComponent={
          isOnline ? (
            pricingEnabled && (
              <BadgeContainer>
                <Badge label={planName} />
              </BadgeContainer>
            )
          ) : (
            <OfflineText>Offline mode</OfflineText>
          )
        }
        // TODO Fleet data
        HeaderComponent={
          <>
            {showFleetData && <Header map={map} />}
            <LocationHeader />
          </>
        }
      >
        {showFleetData && <FleetSideMenuSection />}
        <BoatSideMenuSection addPadding={showFleetData} />
        {pricingEnabled && <SubscriptionSideMenuSection />}
        <ConnectionSideMenuSection />
        <ButtonsContainer>
          {/* <Button
            clickHandler={onlineListenerHandler}
            isSecondary
            label="Send feedback"
          /> */}
          <Button
            stretch
            isSecondary
            clickHandler={openSettingsModal}
            label="Settings"
          />
        </ButtonsContainer>
      </CollapsibleContainer>
    </>
  );
};

export default React.memo(HomeSideMenu);
